// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MSIvj","footer":"styles_footer__3F_L4","passCodeTooltip":"styles_passCodeTooltip__1fvbh"};